const findGuideContent = (guides, type) => {
  if (!guides) return;
  return guides.find((guide) => guide.guideType === type)?.content;
};

export default findGuideContent;
